import type { ContractPromotionSource } from '~/resources/graphql/graphql'

export type AppliedPromotionalCode = {
    contractPromotionId?: string
    code: string
    fullCode: string
    description: string
    source: ContractPromotionSource
    canRemove?: boolean
}

export function getManualPromotionalCodes(
    codes: AppliedPromotionalCode[]
): AppliedPromotionalCode[] {
    // Preview pricing should only send user-managed promo codes. The preview
    // response will add the current auto-applied set back in.
    return codes.filter(code => code.source !== 'AUTO_APPLY')
}

export function getForInput(codes: AppliedPromotionalCode[]): {
    contractPromotionId?: string
    code: string
    fullCode: string
    source: 'MANUAL' | 'AUTO_APPLY'
}[] {
    return codes.map(code => {
        return {
            contractPromotionId: code.contractPromotionId,
            code: code.code,
            fullCode: code.fullCode,
            source: code.source
        }
    })
}

export function hasSameAppliedPromotionalCodes(
    left: AppliedPromotionalCode[],
    right: AppliedPromotionalCode[]
): boolean {
    if (left.length !== right.length) {
        return false
    }

    return left.every((code, index) => {
        const other = right[index]

        return (
            code.contractPromotionId === other.contractPromotionId &&
            code.code === other.code &&
            code.fullCode === other.fullCode &&
            code.description === other.description &&
            code.source === other.source &&
            code.canRemove === other.canRemove
        )
    })
}
